import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		code: null,
		collapsed:null,
		now_app_state:null,
		apps_list:null,
	},
	mutations: {

	},
	actions: {

	}
})

export default store



// WEBPACK FOOTER //
// ./src/client/store/store.js